<template>
  <div id="app">
    <LoginPage v-if="!isLoggedIn" :user="user" @login-success="handleLoginSuccess" />
    <div v-else>
      <MainLay
        v-if="currentPage === 'main'"
        :user="user"
        @logout="handleLogout"
        @go-admin="goToadmin"
        msg="Welcome STNI WebViewer"
      />
      <AdminPage
        v-else-if="currentPage === 'admin'"
        @go-back="goToMain"
      />
    </div>
  </div>
</template>

<script>
import MainLay from "./components/MainLay.vue";
import LoginPage from "./components/LoginPage.vue"; // 로그인 컴포넌트 import
import AdminPage from "./components/AdminPage.vue"; 
import Cookies from "js-cookie";  // js-cookie import

export default {
  name: "App",
  components: {
    MainLay,
    LoginPage,
    AdminPage,
  },
  data() {
    return {
      isLoggedIn: false, // 기본은 로그아웃 상태
      user: null, // 로그인한 사용자 정보 저장
      currentPage: "main", 
    };
  },
  created() {
    const userCookie = Cookies.get("user");
    if (userCookie) {
      this.user = JSON.parse(userCookie);
      this.isLoggedIn = true;
    }
  },
  methods: {
    handleLoginSuccess(userData) {
      this.user = userData; // 로그인한 사용자 정보 저장
      this.isLoggedIn = true;
      Cookies.set("user", JSON.stringify(userData), { expires: 1/8 }); // 1/8 = 3시간 (1일 = 24시간)
    
    },
    handleLogout() {
      this.user = null;
      this.isLoggedIn = false;
      
      Cookies.remove("user");
    },
    goToadmin() {
      this.currentPage = "admin";
    },
    goToMain() {
      this.currentPage = "main";
    },
  },
};
</script>

<style>
html,
body {
  height: 100%;
  margin: 0;
  overflow: hidden;
}

#app {
  width: 100%;
  height: 100%;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  text-align: center;
  color: #2c3e50;
}
</style>
